import type { CompanyBranding } from "@uzverse/contracts";

/** The page's own icon and title (from `index.html`), restored when no company brand applies. */
export const DEFAULT_TITLE = "Uzverse";

const ICON_ID = "uz-brand-icon";

/**
 * Points the browser tab at a company: its app icon as favicon and its name as the title.
 * `null` restores the Uzverse defaults. Logo urls were validated by the contract (https or a path),
 * and the value is only ever assigned to `href`, never parsed as HTML.
 */
export function applyBrandHead(doc: Document, branding: CompanyBranding | null): void {
  const existing = doc.getElementById(ICON_ID);
  if (!branding) {
    existing?.remove();
    doc.title = DEFAULT_TITLE;
    return;
  }
  const link = (existing as HTMLLinkElement | null) ?? doc.createElement("link");
  link.id = ICON_ID;
  link.rel = "icon";
  link.type = "image/png";
  link.href = branding.logo.icon;
  if (!existing) doc.head.appendChild(link);
  doc.title = branding.name;
}
